

export const veo = {
    tabs: {
      textToVideo: '文字轉影片',
      imageToVideo: '圖片轉影片',
      referenceToVideo: '參考圖轉影片'
    },
    preview: {
      emptyTitle: '尚未生成影片',
      emptyDesc: '輸入提示並點擊生成，體驗關鍵幀控制與原生音訊能力',
      hint: '支援文字轉影片、圖片轉影片與參考圖轉影片',
      resultLabel: '已生成',
      download: '下載',
      loadingNew: '正在生成影片...',
      loadingRegenerate: '正在重新生成影片...'
    },
    common: {
      prompt: '提示詞',
      promptPlaceholder: "描述你的影片，例如：『慢動作的小貓玩毛線球，電影級打光，4K 畫質』",
      model: '模型',
      fastMode: '快速模式',
      qualityMode: '高品質模式',
      aspectRatio: '畫面比例',
      aspect169: '16:9 高清',
      aspect916: '9:16',
      aspectAuto: '自動',
      advancedOptions: '進階選項',
      watermark: '浮水印',
      watermarkPlaceholder: '輸入文字浮水印…',
      randomSeed: '隨機種子',
      seedPlaceholder: '10000 - 99999',
      seedDesc: '相同種子會產生相似影片；留空則自動分配',
      autoTranslate: '自動翻譯提示詞',
      autoTranslateDesc: '提示詞將自動翻譯為英文',
      creditsBar: '積分消耗',
      creditsValue: '{count} 積分',
      generateButton: '生成影片（{count} 積分）',
      promptRequired: '請輸入提示詞',
      promptAndImageRequired: '請上傳圖片並輸入提示詞',
      promptAndStartEndRequired: '請上傳起始幀與結尾幀並輸入提示詞',
      promptAndReferenceRequired: '請上傳參考圖片並輸入提示詞',
      requestFailed: '生成請求失敗',
      pollingTimeout: '生成超時',
      pollingFailed: '生成失敗：{msg}'
      ,
      errorTitle: '生成錯誤'
    },
    upload: {
      clickOrDrag: '點擊或拖拽以上傳',
      uploadTitle: '上傳參考圖片',
      formats: '支援 JPEG、PNG、WebP • 最大 10MB',
      selectedCount: '{count}/3 張已選',
      imagesCount: '{count}/3 張'
    },
    reference: {
      info: '參考圖轉影片僅支援快速模式與 16:9 比例。上傳 1–3 張參考圖片以引導生成。'
    },
    keyframe: {
      title: '關鍵幀模式',
      info: '可精準控制影片的起始與結尾幀，使用關鍵幀創造平滑過渡並維持敘事流暢。',
      start: '起始幀',
      end: '結尾幀',
      imageFormats: 'JPG、PNG、WebP • 最大 10MB'
    }
  };
